import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { FixedFeeTerm } from '../../../../../../../../store/fixedFee/types';
import { FixedFeeTermsRowLoading } from '../FixedFeeTermsRowLoading';

import { FixedFeeTermsRowDesktop } from './desktop';
import { FixedFeeTermsRowMobile } from './mobile';

export interface FixedFeeTermsRowProps {
  item: FixedFeeTerm;
}

const FixedFeeTermsRowResponsive: React.FC<FixedFeeTermsRowProps> = (props) => {
  return useBreakpointValue({
    base: <FixedFeeTermsRowMobile {...props} />,
    sm: <FixedFeeTermsRowMobile {...props} />,
    lg: <FixedFeeTermsRowDesktop {...props} />,
  });
};

export const FixedFeeTermsRow = React.memo(FixedFeeTermsRowResponsive);

export { FixedFeeTermsRowLoading };
